<template>
  <v-btn class="mx-2" small fab :loading="loading" :disabled="loading" @click="downloadCsv"  data-toggle="tooltip" title="Export des données au format csv">
    <v-icon dark small>
      mdi-database-export
    </v-icon>
  </v-btn>
</template>

<script>
import Api from "@/core/services/api.service";
import downloadString from "@/core/utils/downloadString";

export default {
  name: "exportBtn",
  data() {
    return {
      loading: false
    };
  },
  props: {
    entity: { type: String, required: true }
  },
  methods: {
    downloadCsv() {
      this.loading = true;
      Api.get(this.entity, '', { headers: { 'Accept': 'text/csv' } })
           .then(content => downloadString(content.data, 'text/csv', this.entity + '.csv'))
           .catch(e => console.log(e))
          .finally(() => this.loading = false);
    }
  }
};
</script>
